<template>
  <div>
    <Breadcrumbs main="Müzeler" title="Liste" :links="breadLinks" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <c-table :tablefields="tablefields" :items="items">
                <template #cell(Islem)="row">
                  <b-btn-group>
                    <router-link
                      :to="`/muze/kayit/${row.item.Id}`"
                      class="btn btn-success btn-xs"
                      >Düzelt</router-link
                    >
                    <b-button size="xs" @click="sil(row.item)" variant="danger"
                      >Sil</b-button
                    >
                  </b-btn-group>
                </template>
                <template #cell(Aktif)="data">
                  <c-aktif-cell :isAktif="data.value"></c-aktif-cell>
                </template>
                <template #cell(GirisUcreti)="row">
                  <c-money-cell
                    :fiyat="row.item.GirisUcreti"
                    :simge="row.item.Simge"
                  ></c-money-cell>
                </template>
                <template #cell(GirisUcretiTL)="row">
                  <c-money-cell
                    :fiyat="row.item.GirisUcretiTL"
                    simge="₺"
                  ></c-money-cell>
                </template>
                <template #cell(KayitTarihi)="row">
                  <c-tarih-cell
                    :kayitTarihi="row.item.KayitTarihi"
                    :guncelTarih="row.item.GuncelTarih"
                    :rowKey="row.item.Id"
                  ></c-tarih-cell>
                </template>
              </c-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadLinks: [{ path: "/muze/kayit", title: "Ekle", icon: "plus" }],
      tablefields: [
        { key: "Islem", label: "İşlemler", sortable: false },
        { key: "Tanim", label: "Müze Adı", sortable: true },
        { key: "GirisUcreti", label: "Giriş Ücreti", sortable: true },
        { key: "GirisUcretiTL", label: "Giriş Ücreti (₺)", sortable: true },
        { key: "Aktif", label: "Aktif", sortable: true },
        { key: "KullaniciAdi", label: "Kullanıcı", sortable: true },
        { key: "KayitTarihi", label: "Kayıt Tarihi", sortable: true },
      ],

      items: [],
    };
  },
  mounted() {
    this.onList();
  },
  methods: {
    onList() {
      let vm = this;

      this.$connection.get("/muzeler", function (response) {
        vm.items = response;
      });
    },
    sil(item) {
      let vm = this;
      this.$alert.confirm(
        "Sil",
        "Müze kaydını silmek istediğinize emin misiniz?",
        "warning",
        function () {
          vm.$connection.delete("/muzeler/" + item.Id, function (response) {
            vm.$alert.messageWithFunction(
              "Silindi",
              "Müze kaydı silindi.",
              "error",
              function () {
                vm.$listHelper.removeItem(vm.items, item);
              }
            );
          });
        }
      );
    },
  },
};
</script>
